<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <ion-back-button icon="arrow-back-outline" text="" defaultHref="login"></ion-back-button>
    </ion-button>
    <ion-title>{{'Selecionar Unidade' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <ng-container *ngIf="loadedPage">
    <p class="titulo-pergunta">{{ configAutoCadastro.perguntaFrequentaInst }}</p>

    <ion-radio-group [(ngModel)]="frequentaInstPergunta" value="end" class="radio"
      (ionChange)="onFrequentaInstChange($event)">
      <ion-item>
        <ion-radio value="1" labelPlacement="end" justify="start">
          <ion-label>
            {{ 'Sim' | translate}}
          </ion-label>
        </ion-radio>
      </ion-item>

      <ion-item>
        <ion-radio value="0" labelPlacement="end" justify="start">
          <ion-label>
            {{ 'Não' | translate}}
          </ion-label>
        </ion-radio>
      </ion-item>
    </ion-radio-group>

    <div *ngIf="exibirPergunta">
      <p class="titulo-pergunta">
        {{ 'A unidade em que você faz parte é do Brasil ou Exterior?' | translate }}
      </p>


      <ion-radio-group [(ngModel)]="localizacaoPergunta" value="end" class="radio"
        (ionChange)="onLocalizacaoChange($event)">
        <ion-item>
          <ion-radio value="brasil" labelPlacement="end" justify="start">
            <ion-label>
              {{ 'Brasil' | translate}}
            </ion-label>
          </ion-radio>
        </ion-item>

        <ion-item>
          <ion-radio value="exterior" labelPlacement="end" justify="start">
            <ion-label>
              {{ 'Exterior' | translate}}
            </ion-label>
          </ion-radio>
        </ion-item>
      </ion-radio-group>
    </div>
  </ng-container>
</ion-content>

<ion-footer *ngIf="loadedPage">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col size="6">
          <ion-button expand="block" class="btn-prover" (click)="voltar()">
            {{ 'VOLTAR' | translate }}
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button expand="block" class="btn-prover" [disabled]="!canNext" (click)="selecionar()">
            {{ 'CONTINUAR' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>